import * as React from 'react';
import { BlockContent, BlockType } from '../../../../commonv3/types/block';
import { VideoBlockContentPane } from './VideoBlockContentPane';
import { ImageBlockContentPane } from './ImageBlockContentPane';
import { SlideshowBlockContentPane } from './SlideshowBlockContentPane';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3MembershipPlanKey } from '../../../../mainv2/types/user';
import { DummyImageBlockContentPane } from './DummyImageBlockContentPane';
import { observer } from 'mobx-react';

type Props = {
    blockType: BlockType;
    content: BlockContent;
};

export const BlockContentPane = observer(({ blockType, content }: Props) => {
    const user = GlobalStatesV3.currentUser.currentUser;
    switch (blockType) {
        case 'video':
            if (user.membership_plan_keys.includes(V3MembershipPlanKey.PLANNER)) {
                return <DummyImageBlockContentPane />;
            } else {
                return <VideoBlockContentPane content={content} />;
            }
        case 'image':
            return <ImageBlockContentPane content={content} />;
        case 'slideshow':
            return <SlideshowBlockContentPane content={content} />;
    }
});
